import { Button, FormGroup, Modal } from "react-bootstrap";
import { dateFormatUtcToYMD } from "src/utils/dateManagement";
import { PayPalButton } from "react-paypal-button-v2";
import useBillStatement from "src/hooks/Modal/Bill/useBillStatement";
import { localStrings } from "src/utils/localization";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";

interface IChangeLicenseCountModalProps {
  modal: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  payTerm?: string;
  payCompany?: string;
  serviceList: any;
  changePrice: any;
  changeNextPayDate: any;
  changePriceIncTax: any;
  confirmPrice: (orderId: any, type: any, authorizationID: any) => void;
  toggleModalConfirmPayTerm: () => void;
  changePayTerm: any;
  checkConfirmPayTerm: () => void;
}

// 결제 주기 변경 모달 (추후 다시 만들 것!!)
const ChangeLicenseCountModal = ({
  modal,
  payTerm,
  payCompany = "INICIS",
  handleChange,
  changePrice,
  changeNextPayDate,
  changePriceIncTax,
  confirmPrice,
}: // goPrint,
IChangeLicenseCountModalProps) => {
  const { payInfoModalState, togglePayInfoModal } = useBillStatement();
  const licenseCount = 0;
  const changeLicenseCount = 0;
  const checkProductName = false;
  const currency = "WON";
  const userPerPrice = 0;
  const toggleModalCheckConfirmUser = () => {};
  const { t } = useTranslation();
  const { lang } = useRouter();
  return (
    <>
      <Modal
        show={payInfoModalState?.licenseCount}
        onHide={() => togglePayInfoModal({ info: "licenseCount" })}
        className="confirm__period"
        style={{ opacity: 1 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t("siteManagement.paymentHistory.popUp.changeNumberOfUsers.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <div className="flex justify-space-between mg mb-16">
              <b className="text text--13">
                {t(
                  "siteManagement.paymentHistory.popUp.changeNumberOfUsers.beforeChange"
                )}
              </b>
              <span className="text text--right text--bold">
                {licenseCount}
              </span>
            </div>
            <div className="flex justify-flex-end mg mb-16">
              <input
                type="number"
                step="1"
                id="changeLicenseCount"
                name="changeLicenseCount"
                value={changeLicenseCount}
                onChange={handleChange}
                min={0}
                max={9999 - licenseCount}
                className="form-control text-right width max-w-150"
              />
            </div>
            <div className="flex justify-space-between mg mb-16">
              <b className="text text--13">
                {t(
                  "siteManagement.paymentHistory.popUp.changeNumberOfUsers.afterChange"
                )}
              </b>
              <span className="text text--right text--bold">
                {Number(licenseCount) + Number(changeLicenseCount)}
              </span>
            </div>
            {changePrice > 0 ? (
              <div>
                <p className="text text--gray text--13">
                  {payTerm === "year" ? (
                    <span>
                      {/* 결제 주기 : 년 1회 */}
                      {checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.annual.Msg1"
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              +"info.annual.Msg1"
                          )}
                      <br />
                      <>
                        {/* {checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.annual.Msg1",
                            Number(licenseCount) + Number(changeLicenseCount)
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                              (lang === "ko"
                                ? "KRW."
                                : "USD.") +
                              "info.annual.Msg2",
                            Number(licenseCount) + Number(changeLicenseCount)
                          )} */}
                      </>
                      <br />
                      <>
                        {checkProductName
                          ? t(
                              "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.annual.Msg3",
                              currency === "WON"
                                ? t("subscriptionType.fee.won")
                                : t("subscriptionType.dollar") +
                                    t("subscriptionType.fee.dollar"),
                              changePrice.toLocaleString()
                            )
                          : t(
                              "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                                (lang === "ko" ? "KRW." : "USD.") +
                                "info.annual.Msg3",
                              currency === "WON"
                                ? t("subscriptionType.fee.won")
                                : t("subscriptionType.dollar") +
                                    t("subscriptionType.fee.dollar"),
                              changePrice.toLocaleString()
                            )}
                      </>
                      <br />
                      <>
                        {checkProductName
                          ? t(
                              "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.annual.Msg3_1",
                              changePrice
                            )
                          : t(
                              "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                                (lang === "ko" ? "KRW." : "USD.") +
                                "info.annual.Msg3_1",
                              changePrice
                            )}
                      </>
                      <br />
                      {/* {t(
                        checkProductName
                          ? "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.annual.Msg4"
                          : "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                              (lang === "ko"
                                ? "KRW."
                                : "USD.") +
                              "info.annual.Msg4",
                        dateFormatUtcToYMD(changeNextPayDate),
                        Number(changeLicenseCount) + Number(licenseCount),
                        currency === "WON"
                          ? t("subscriptionType.fee.won")
                          : t("subscriptionType.dollar") +
                              t("subscriptionType.fee.dollar"),
                        (
                          Number(userPerPrice) *
                          (Number(changeLicenseCount) + Number(licenseCount)) *
                          12
                        ).toLocaleString()
                      )} */}
                      <br />
                      <br />
                      {checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.annual.Msg5"
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.annual.Msg5"
                          )}
                    </span>
                  ) : (
                    <span>
                      {/* 결제 주기 : 매월 */}
                      {checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.monthly.Msg1"
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.monthly.Msg1"
                          )}
                      <br />
                      <>
                        {/* {checkProductName
                        ? t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.monthly.Msg2",
                            Number(licenseCount) + Number(changeLicenseCount)
                          )
                        : t(
                            "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                              (lang === "ko"
                                ? "KRW."
                                : "USD.") +
                              "info.monthly.Msg2",
                            Number(licenseCount) + Number(changeLicenseCount)
                          )} */}
                      </>
                      <br />
                      <>
                        {t(
                          checkProductName
                            ? "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.monthly.Msg3"
                            : "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                                (lang === "ko" ? "KRW." : "USD.") +
                                "info.monthly.Msg3",
                          currency === "WON"
                            ? t("subscriptionType.fee.won")
                            : t("subscriptionType.dollar") +
                                t("subscriptionType.fee.dollar"),
                          changePrice.toLocaleString()
                        )}
                      </>
                      <br />
                      <>
                        {t(
                          checkProductName
                            ? "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.monthly.Msg3_1"
                            : "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                                (lang === "ko" ? "KRW." : "USD.") +
                                "info.monthly.Msg3_1",
                          currency === "WON"
                            ? t("subscriptionType.fee.won")
                            : t("subscriptionType.dollar") +
                                t("subscriptionType.fee.dollar"),
                          changePrice.toLocaleString()
                        )}
                      </>
                      <br />
                      <>
                        {/* {t(
                        checkProductName
                          ? "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.monthly.Msg4"
                          : "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                              (lang === "ko"
                                ? "KRW."
                                : "USD.") +
                              "info.monthly.Msg4",
                        dateFormatUtcToYMD(changeNextPayDate),
                        Number(changeLicenseCount) + Number(licenseCount),
                        currency === "WON"
                          ? t("subscriptionType.fee.won")
                          : t("subscriptionType.dollar") +
                              t("subscriptionType.fee.dollar"),
                        (
                          Number(userPerPrice) *
                          (Number(changeLicenseCount) + Number(licenseCount))
                        ).toLocaleString()
                      )} */}
                      </>
                      <br />
                      <br />
                      {t(
                        checkProductName
                          ? "siteManagement.paymentHistory.popUp.changeNumberOfUsers.eco.info.monthly.Msg5"
                          : "siteManagement.paymentHistory.popUp.changeNumberOfUsers.wrapsody." +
                              (lang === "ko" ? "KRW." : "USD.") +
                              "info.monthly.Msg5"
                      )}
                    </span>
                  )}
                </p>
              </div>
            ) : (
              ""
            )}
          </FormGroup>
        </Modal.Body>
        {changePrice > 0 ? (
          payCompany === "PAYPAL" ? (
            <Modal.Footer>
              <PayPalButton
                createOrder={(data: any, actions: any) => {
                  return actions.order.create({
                    purchase_units: [
                      {
                        amount: {
                          value: changePriceIncTax,
                        },
                      },
                    ],
                  });
                }}
                onApprove={(data: any, actions: any) => {
                  // Capture the funds from the transaction
                  return actions.order
                    .authorize()
                    .then(function (authorization: any) {
                      // Show a success message to your buyer
                      confirmPrice(
                        data.orderID,
                        "user",
                        authorization.purchase_units[0].payments
                          .authorizations[0].id
                      );
                    });
                }}
              />
            </Modal.Footer>
          ) : (
            // 현금 결제 시 현금 결제 옵션 추가 필요
            <Modal.Footer>
              <Button
                className={"btn btn-green btn-40 width w-100p pd py-10"}
                onClick={toggleModalCheckConfirmUser}
              >
                <img
                  className="card mg mr-10"
                  src="/resources/images/card.png"
                  alt=""
                />
                {/* 체크카드 및 신용카드 */}
                {t("common.card")}
              </Button>
            </Modal.Footer>
          )
        ) : (
          ""
        )}
      </Modal>
    </>
  );
};

export default ChangeLicenseCountModal;
